import { MessageGroup, SchoolSettings } from '@/plugins/api.js'
import { get } from 'lodash'
import moment from 'moment'
export default {
  namespaced: true,
  state: {
    settings: {},
    currentSchoolYear: {},
    currentSemester: {},
    hasUnreadMessage: false,
    isMinimized: false
  },
  actions: {
    setMinimized({ state, commit }) {
      commit('changeState', { isMinimized: !state.isMinimized })
    },
    // School setting
    async fetchSchoolSettings({ commit }) {
      const response = await SchoolSettings.fetch()
      commit('setSettings', response)
      commit('setCurrentSchoolYear', response.currentSchoolYear)
      commit('setCurrentSemester', response.currentSemester)
      localStorage.setItem('currentYear', get(response, 'currentSchoolYear.code'))
    },
    async updateSchoolSettings({ commit }, updateData) {
      const response = await SchoolSettings.update(updateData)
      commit('setSettings', response)
    },
    async checkUnReadMessage({ commit }, query) {
      const params = {
        ...query,
        lastMessageSenderType: 'student',
        _sort: 'lastMessageTime:desc',
        _limit: 1
      }
      let hasUnreadMessage = false
      const results = await MessageGroup.fetch(params)
      if (results && results[0]) {
        const latestMessageGroup = results[0]
        if (moment(latestMessageGroup.schollSideLastSeen).isBefore(moment(latestMessageGroup.lastMessageTime))) {
          hasUnreadMessage = true
        }
      }
      commit('changeState', { hasUnreadMessage })
    },
    reset({ commit }) {
      commit('reset')
    }
  },
  mutations: {
    setSettings(state, settings) {
      state.settings = settings
    },
    setCurrentSchoolYear(state, schoolYear) {
      state.currentSchoolYear = schoolYear
      state.currentSchoolYearId = get(schoolYear, 'id', '')
    },
    setCurrentSemester(state, semester) {
      state.currentSemester = semester
      state.currentSemesterId = semester.id
    },
    reset(state) {
      state.currentSchoolYear = {}
      state.currentSemester = {}
    }
  },
  getters: {
    currentSchoolYear(state) {
      return state.currentSchoolYear ? state.currentSchoolYear : {}
    },
    currentSchoolYearId(state) {
      return state.currentSchoolYear ? state.currentSchoolYear.id : ''
    },
    currentSemester(state) {
      return !state.currentSemester ? {} : state.currentSemester
    },
    currentSemesterId(state) {
      return state.currentSemester ? state.currentSemester.id : ''
    },
    schoolYearStartDate(state) {
      return get(state.currentSchoolYear, 'startDate', moment().toISOString())
    },
    schoolYearEndDate(state) {
      return get(state.currentSchoolYear, 'endDate', moment().toISOString())
    },
    getIsMinimized(state) {
      return state.isMinimized
    }
  }
}
